export const errorListScroll = (list) => {
	Object.values(list?.items)
		?.find((i) => i.value)
		?.ref?.current?.scrollIntoView({block: "center", inline:"center", behavior: "smooth"});
};
